import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import { useCustomerDetailsStyles } from './CustomerDetails';
import {
  getVehicleType,
  shouldDisplayVehicleType,
} from '../../VehicleConstants';
import VehicleEdit from './VehicleEdit';
import { apiGet } from '../../brainApi';

const VehicleRow = ({ vehicle }) => {
  const classes = useCustomerDetailsStyles();
  const [vehicleImageUrl, setVehicleImageUrl] = useState('');
  const [openVehicleEdit, setOpenVehicleEdit] = useState(false);

  const { id, display_name, license_plate_number, license_plate_state, vin } =
    vehicle || {};

  useEffect(() => {
    apiGet(`/technician-app/vehicle-image/${id}`).then(({ image_link }) =>
      setVehicleImageUrl(image_link),
    );
  }, []);

  const licensePlateInfo = [license_plate_number, license_plate_state]
    .filter(Boolean)
    .join(' ');
  const vehicleType = shouldDisplayVehicleType() && getVehicleType(vehicle);

  return (
    <Grid item key={id}>
      <Grid container spacing={1} alignItems="center" wrap="nowrap">
        <Grid item xs={1} className={classes.vehicleImage}>
          {vehicleImageUrl ? (
            <img src={vehicleImageUrl} alt="vehicle" className={classes.w100} />
          ) : (
            <div className={classes.w100}>
              <DriveEtaIcon fontSize="large" />
            </div>
          )}
        </Grid>
        <Grid item xs className={classes.cardTextContent}>
          <Typography className={classes.fw500}>{display_name}</Typography>
          <Typography>{licensePlateInfo}</Typography>
          <Typography>{vin}</Typography>
          <Typography className={classes.gray}>{vehicleType}</Typography>
        </Grid>
        <Grid item>
          <IconButton size="small" onClick={() => setOpenVehicleEdit(true)}>
            <EditIcon />
          </IconButton>
        </Grid>
      </Grid>
      {openVehicleEdit && (
        <VehicleEdit
          openEdit={openVehicleEdit}
          setOpenEdit={setOpenVehicleEdit}
          id={id}
        />
      )}
    </Grid>
  );
};

export default VehicleRow;
